import { render, staticRenderFns } from "./RunnitBoardsDashboard.vue?vue&type=template&id=73896800"
import script from "./RunnitBoardsDashboard.vue?vue&type=script&lang=ts"
export * from "./RunnitBoardsDashboard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports